import { render, staticRenderFns } from "./UpgradeClient.vue?vue&type=template&id=440c213a&scoped=true&"
import script from "./UpgradeClient.vue?vue&type=script&lang=js&"
export * from "./UpgradeClient.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeClient.vue?vue&type=style&index=0&id=440c213a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440c213a",
  null
  
)

export default component.exports